<ngx-spinner
    color="var(--primary-color)"
    bdColor="rgba(51, 51, 51, 0.1)"
    type="ball-clip-rotate"
    [fullScreen]="false"
    size="medium"
></ngx-spinner>
